import { use } from "react";
import {
  type WizardActions,
  WizardActionsContext,
  type WizardState,
  WizardStateContext,
} from "../WizardContext";

export const useWizard = <TStepName extends string = string>(): WizardState &
  WizardActions<TStepName> => {
  const state = use(WizardStateContext);
  const actions = use(WizardActionsContext);

  if (!state || !actions) {
    throw new Error("useWizard must be used within Wizard.Root");
  }

  return { ...state, ...actions } as const;
};
